import {
    ExternalPermissions,
    ExternalPermissionsOptionList,
    ExternalTeamMemberRole,
    InternalPermissions,
    InternalPermissionsOptionList,
    InternalTeamMemberRole,
    TeamMemberType,
} from './Models/Enums';

export interface TeamMemberPermissions {
    permission: InternalPermissions | ExternalPermissions;
    role?: InternalTeamMemberRole | ExternalTeamMemberRole;
    type: TeamMemberType;
    isPrimaryBuyer: boolean;
}

export class TeamMemberPermissionsHelper {
    static requiredViewPermissions = {
        permission: InternalPermissions.ReadOnly,
        role: null,
        type: TeamMemberType.Internal,
    } as TeamMemberPermissions;
    static requiredEditPermissions = {
        permission: InternalPermissions.ReadOnlyAndCommunicateAndExecute,
        role: null,
        type: TeamMemberType.Internal,
    } as TeamMemberPermissions;

    static isAvailable(
        permissions: TeamMemberPermissions,
        requiredPermissions: TeamMemberPermissions
    ): boolean {
        if (permissions.isPrimaryBuyer) {
            return true;
        }

        if (permissions.type !== requiredPermissions.type) {
            return false;
        }

        if (
            permissions.type === TeamMemberType.Internal &&
            requiredPermissions.type === TeamMemberType.Internal
        ) {
            if (
                requiredPermissions.role === InternalTeamMemberRole.CorpDev &&
                permissions.role !== InternalTeamMemberRole.CorpDev
            ) {
                return false;
            }

            if (requiredPermissions.permission > permissions.permission) {
                return false;
            }
            return true;
        }

        if (
            permissions.type === TeamMemberType.External &&
            requiredPermissions.type === TeamMemberType.External
        ) {
            if (requiredPermissions.permission > permissions.permission) {
                return false;
            }
            return true;
        }

        return false;
    }

    static getInternalPermissionLabel(
        permissions: InternalPermissions
    ): string {
        return InternalPermissionsOptionList.find(
            (x) => x.value === permissions
        )?.label;
    }

    static getExternalPermissionLabel(
        permissions: ExternalPermissions
    ): string {
        return ExternalPermissionsOptionList.find(
            (x) => x.value === permissions
        )?.label;
    }
}
